import * as actionTypes from './actionTypes';

export const toggleSidebar = (isSidebarOpened) => {
  return {
    type: actionTypes.TOGGLE_SIDEBAR,
    isSidebarOpened: isSidebarOpened
  };
};